import { jsx as _jsx } from "react/jsx-runtime";
export const NavbarBrand = ({ children, href }) => (_jsx("a", { href: href, className: "flex items-center", children: children }));
